export function store(jobId, data)
{
    return axios.post(route('api.manage.jobs.noteAttachment.upload', {jobId}), data)
        .then(response => response.data);
}

export function destroy(jobId, attachmentId)
{
    return axios.delete(route('api.manage.jobs.noteAttachment.destroy', {
        jobId,
        attachmentId
    }));
}
